<ion-header>

  <ion-toolbar hideBackButton="true">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>{{dialogTitle}}</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page2" no-bounce class="master">
  <div class="v-box" style="height: 100%">
    <div class="completionMessage" translate>
      DIALOGS.COMPLETION
    </div>
  </div>
</ion-content>

<ion-footer class="ion-padding page2">
  <ion-button fill="solid" shape="round" expand="block" color="light" style="width: 100%" (click)="onFinishClick()"><div translate>COMMON.FINISH</div></ion-button>
</ion-footer>
